import { RoutesList } from '@/routes/routesList';

export const secondaryNavObj = [
  {
    label: 'weeklyCapture',
    href: RoutesList.WeeklyCapturePage,
    showSecondaryNavBar: true,
    showWeekNavigator: true,
    showCompleteWeekButton: true,
  },
  {
    label: 'weeklyPlan',
    href: RoutesList.MyPlanPage,
    showSecondaryNavBar: true,
    showWeekNavigator: true,
    showCompleteWeekButton: true,
  },
  {
    label: 'weeklyReflection',
    href: RoutesList.CelebratePage,
    showSecondaryNavBar: true,
    showWeekNavigator: true,
    showCompleteWeekButton: false,
  },
  {
    label: 'dailyPlan',
    href: RoutesList.MyPlanDailyPage,
    showSecondaryNavBar: true,
    showWeekNavigator: true,
    showCompleteWeekButton: true,
  },
  {
    label: 'activeProjects',
    href: RoutesList.ProjectsPage,
    showSecondaryNavBar: true,
    showWeekNavigator: false,
    showCompleteWeekButton: false,
  },
  {
    label: 'activeCategories',
    href: RoutesList.CategoryManagerPage,
    showSecondaryNavBar: true,
    showWeekNavigator: false,
    showCompleteWeekButton: false,
  },
];

export const PLAN_SCHEDULE_PAGE_INDEX = [
  {
    value: 0,
    label: 'Plan',
  },
  {
    value: 1,
    label: 'Schedule',
  },
];
